import { showToast } from '@/features/toasts/toastsSlice';
import { useWorkspace } from '@/features/workspaces/hooks';
import { DeleteModalWithConfirmInput } from '@/lib/Modals';
import { Audience } from '@/models/audiences';
import { ToastType } from '@/models/toast';
import { useAppDispatch } from '@/reducers';
import { useDeleteAudienceMutation } from '@/services/endpoints/audiences';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

type DeleteAudienceModalProps = {
  audience?: Audience;
  closeModal: VoidFunction;
};

export const DeleteAudienceModal: FC<DeleteAudienceModalProps> = ({ audience, closeModal }) => {
  const { t } = useTranslation('audience_details');

  const workspace = useWorkspace();

  const [deleteAudience, { isLoading, isSuccess }] = useDeleteAudienceMutation();

  const dispatch = useAppDispatch();
  const history = useHistory();

  const handleDeleteAudienceClicked = async () => {
    if (workspace.id && audience && audience.id)
      deleteAudience({
        workspaceId: workspace.id,
        audienceId: audience.id,
      });
  };

  useEffect(() => {
    if (isSuccess) {
      closeModal();
      history.push('/audiences');

      dispatch(
        showToast({
          type: ToastType.SUCCESS,
          title: t('settings.delete.audience_eliminated'),
          message: t('settings.delete.removed_successfully', { audienceName: audience?.name }),
        })
      );
    }
  }, [isSuccess]);

  return (
    <DeleteModalWithConfirmInput
      inputComparisonValue={audience.name}
      confirmText='audience_details.settings.delete.delete_this_audience'
      onConfirm={handleDeleteAudienceClicked}
      onClose={closeModal}
      isLoading={isLoading}
    >
      <DeleteModalWithConfirmInput.Title>{t('settings.delete.delete_edit_title')}</DeleteModalWithConfirmInput.Title>

      <DeleteModalWithConfirmInput.InputHint>
        {t('settings.delete.confirm_deletion')}&nbsp;(<b className='whitespace-pre-wrap'>{audience?.name}</b>)
      </DeleteModalWithConfirmInput.InputHint>
    </DeleteModalWithConfirmInput>
  );
};
